import React from 'react';

// 거래명세서·세금계산서 공용 진행 스테퍼 + "다음 할 일" 안내줄 (2026-07-19 흐름 통일)
// steps: ['작성 중','발행됨','치과 확인','정산 완료'] 등
// current: 현재 단계 index (이전 단계는 ✓ 완료, steps.length 이상이면 전체 완료)
// tone: 'pri' 진행 | 'wait' 대기 | 'warn' 수정요청 | 'done' 완료
const TONES = {
    pri: { bg: '#EEF2FF', color: '#4338CA' },
    wait: { bg: '#FFF7E8', color: '#B45309' },
    warn: { bg: '#FEF2F2', color: '#DC2626' },
    done: { bg: '#F0FDF4', color: '#15803D' },
};

const DONE_COLOR = '#15803D';
const NOW_COLOR = '#6366F1';
const OFF_COLOR = '#CBD5E1';

function FlowBar({ steps, current, tone = 'pri', message, small }) {
    const t = TONES[tone] || TONES.pri;
    const allDone = current >= steps.length;

    return (
        <div className="no-print" style={{ marginBottom: 14 }}>
            {/* 스테퍼 */}
            <div style={{ display: 'flex', alignItems: 'flex-start', padding: '4px 4px 0' }}>
                {steps.map((label, i) => {
                    const isDone = allDone || i < current;
                    const isNow = !allDone && i === current;
                    const dotColor = isDone ? DONE_COLOR : isNow ? NOW_COLOR : OFF_COLOR;
                    return (
                        <div key={label} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', minWidth: 0 }}>
                            {i > 0 && (
                                <div style={{ position: 'absolute', top: 13, left: '-50%', width: '100%', height: 2.5, background: (isDone || isNow) ? DONE_COLOR : OFF_COLOR }} />
                            )}
                            <div style={{
                                width: 27, height: 27, borderRadius: '50%', zIndex: 1,
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: 12.5, fontWeight: 800, color: '#fff', background: dotColor,
                                boxShadow: isNow ? '0 0 0 4px #EEF2FF' : 'none',
                            }}>
                                {isDone ? '✓' : i + 1}
                            </div>
                            <div style={{ fontSize: 11.5, fontWeight: 700, marginTop: 6, color: isDone ? DONE_COLOR : isNow ? NOW_COLOR : '#94A3B8', textAlign: 'center' }}>
                                {label}
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* 다음 할 일 안내 */}
            {message && (
                <div style={{ marginTop: 10, padding: '10px 14px', borderRadius: 10, background: t.bg, color: t.color, fontSize: 13.5, fontWeight: 600, display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                    <span aria-hidden="true">👉</span>
                    <div>
                        {message}
                        {small && <div style={{ fontWeight: 500, opacity: 0.85, marginTop: 2, fontSize: 12 }}>{small}</div>}
                    </div>
                </div>
            )}
        </div>
    );
}

export default FlowBar;
